import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group
} from '@angular/animations';

@Component({
  selector: 'app-r-q23',
  templateUrl: './r-q23.component.html',
  styleUrls: ['./r-q23.component.css', '../residential-question.component.css'],
  animations: [
    trigger('flyInOut', [
      state('in', style({
        transform: 'translateX(0)', opacity: 1
      })),
      transition('void => *', [
        style({transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate('0.4s 0.1s ease', style({
            transform: 'translateX(0)',
          })),
          animate('0.4s ease', style({
            opacity: 1
          }))
        ])
      ]),
      transition('* => void', [
        group([
          animate('0.4s ease', style({
            transform: 'translateX(50px)',
          })),
          animate('0.4s 0.2s ease', style({
            opacity: 0
          }))
        ])
      ])
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' }))
      ])
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100)
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]
})
export class RQ23Component implements OnInit {

  @Input() data: any;
  question;
  questions;
  user_bot = false;
  userResponses = [];
  index;
  questionObj;
  isChecked;
  showTip = false;
  hgLeds = {
    led_option1: false,
    led_option2: false,
    led_option3: false,
    led_option4: false,
  };
  showbutton = true;
  number;
  messagetype;
  deviceWidth;
  led1_id;
  led2_id;
  led3_id;
  led4_id;
  timer;
  typingTimer;
  showTyping = false;
  time = 1000;

  constructor(private residentialService: ResidentialService) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      if (this.showTip) {
        if (this.typingTimer) {
        clearTimeout(this.typingTimer);
        this.showTyping = false;
      }
      this.typingTimer = setTimeout(() => {
        this.showTyping = true;
      }, 250);
      this.time = 2000;
    }
      this.timer = setTimeout(() => {
        this.showTyping = false;
        this.next();
      }, 0);
    }
  }

  ngOnInit() {
    this.residentialService.currentId = this.data;
    if (this.deviceWidth < 768) {
      this.led1_id = document.getElementById('led1_mob');
      this.led2_id = document.getElementById('led2_mob');
      this.led3_id = document.getElementById('led3_mob');
      this.led4_id = document.getElementById('led4_mob');
    } else {
      this.led1_id = document.getElementById('led1');
      this.led2_id = document.getElementById('led2');
      this.led3_id = document.getElementById('led3');
      this.led4_id = document.getElementById('led4');
    }
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        // If the flow is from renewal -> show 'renewal_question' text
        if (this.residentialService.questionFlowType === 'renewal') {
          this.question = this.questions[i].renewal_question;
        }
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, { 'res_question_id': this.questionObj._id });
      if (!_.isEmpty(obj)) {
        this.number = obj.fieldValue;
        if (!_.isEmpty(this.number)) {
          if (this.number === 'None') {
            this.hgLeds = {
              led_option1: true,
              led_option2: false,
              led_option3: false,
              led_option4: false,
            };
            this.led1_id.parentElement.classList.add('active-select');
          } else if (this.number === 'Only the main lights') {
            this.hgLeds = {
              led_option1: false,
              led_option2: true,
              led_option3: false,
              led_option4: false,
            };
            this.led2_id.parentElement.classList.add('active-select');
          } else if (this.number === 'All light fixtures') {
            this.hgLeds = {
              led_option1: false,
              led_option2: false,
              led_option3: true,
              led_option4: false,
            };
            this.led3_id.parentElement.classList.add('active-select');
          } else if (this.number === "What's LED?") {
            this.hgLeds = {
              led_option1: false,
              led_option2: false,
              led_option3: false,
              led_option4: true,
            };
            this.led4_id.parentElement.classList.add('active-select');
          }
          this.showTip = true;
          this.user_bot = true;
          if (this.deviceWidth < 768) {
            this.goNext();
          }
        }
      }
    }
    this.messagetype = this.residentialService.messervicetype;

    
    if(!this.hgLeds.led_option1 && !this.hgLeds.led_option2 && !this.hgLeds.led_option3 && !this.hgLeds.led_option4)
    {
      this.showbutton = false;
    }
  }

  getQuantity(event) {
    this.number = event.target.value;
    this.isChecked = event.target.checked;
    if (this.isChecked === true) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
      if (this.number === 'None') {
        this.hgLeds = {
          led_option1: true,
          led_option2: false,
          led_option3: false,
          led_option4: false,
        };
        this.led1_id.parentElement.classList.add('active-select');
        if (_.contains(this.led2_id.parentElement.classList, 'active-select')) {
          this.led2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led3_id.parentElement.classList, 'active-select')) {
          this.led3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led4_id.parentElement.classList, 'active-select')) {
          this.led4_id.parentElement.classList.remove('active-select');
        }
      } else if (this.number === 'Only the main lights') {
        this.hgLeds = {
          led_option1: false,
          led_option2: true,
          led_option3: false,
          led_option4: false,
        };
        this.led2_id.parentElement.classList.add('active-select');
        if (_.contains(this.led1_id.parentElement.classList, 'active-select')) {
          this.led1_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led3_id.parentElement.classList, 'active-select')) {
          this.led3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led4_id.parentElement.classList, 'active-select')) {
          this.led4_id.parentElement.classList.remove('active-select');
        }
      } else if (this.number === 'All light fixtures') {
        this.hgLeds = {
          led_option1: false,
          led_option2: false,
          led_option3: true,
          led_option4: false,
        };
        this.led3_id.parentElement.classList.add('active-select');
        if (_.contains(this.led2_id.parentElement.classList, 'active-select')) {
          this.led2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led1_id.parentElement.classList, 'active-select')) {
          this.led1_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led4_id.parentElement.classList, 'active-select')) {
          this.led4_id.parentElement.classList.remove('active-select');
        }
      } else if (this.number === "What's LED?") {
        this.hgLeds = {
          led_option1: false,
          led_option2: false,
          led_option3: false,
          led_option4: true,
        };
        this.led4_id.parentElement.classList.add('active-select');
        if (_.contains(this.led2_id.parentElement.classList, 'active-select')) {
          this.led2_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led3_id.parentElement.classList, 'active-select')) {
          this.led3_id.parentElement.classList.remove('active-select');
        }
        if (_.contains(this.led1_id.parentElement.classList, 'active-select')) {
          this.led1_id.parentElement.classList.remove('active-select');
        }
      }
      this.showTip = true;
      this.user_bot = true;
    } else {
      this.hgLeds = {
        led_option1: false,
        led_option2: false,
        led_option3: false,
        led_option4: false,
      };
      this.number = '';
      this.showTip = false;
      this.user_bot = false;
      if (_.contains(this.led1_id.parentElement.classList, 'active-select')) {
        this.led1_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.led2_id.parentElement.classList, 'active-select')) {
        this.led2_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.led3_id.parentElement.classList, 'active-select')) {
        this.led3_id.parentElement.classList.remove('active-select');
      }
      if (_.contains(this.led4_id.parentElement.classList, 'active-select')) {
        this.led4_id.parentElement.classList.remove('active-select');
      }
    }
    this.save();
    if (this.deviceWidth < 768) {
      this.goNext();
    }else
    {
      if (this.isChecked === true)
      {
          if(!this.showbutton)
          {
            this.next();
          }
  
      }
    }
  }
  next() {
    if (_.isEmpty(this.number)) {
      // console.log.log('led_lights_ns:', this.number);
      // alert('Select the Option');
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({'currentId': this.data});
      }
    } else {
      this.residentialService.messageService({ 'currentId': this.data });
    }
  }
  // This function is used for to save the data in DB
  save() {
    const Obj = {
      'res_question_id': this.data, 'fieldName': 'led_lights_ns', 'fieldValue': this.number
    };
    this.residentialService.updateResponses(Obj);
  }

}
